import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Measurement } from '../../models/tools/measurement.model';
import type { RangeRingPoint } from '../../models/tools/range-ring.model';

export enum ToolsPanelViewState {
  MENU = 'tools-menu',
  MEASURING_TOOL = 'measuring-tool',
  NEARBY_VESSELS = 'nearby-vessels',
  RANGE_RINGS = 'range-rings',
  WEATHER = 'weather',
  HISTORIC_VESSELS = 'historic-vessels',
}

interface ToolsState {
  viewState: ToolsPanelViewState;
  rangeRings: {
    points: RangeRingPoint[];
  };
  measuringTool: {
    measurements: Measurement[];
  };
}

export const INITIAL_TOOLS_STATE: ToolsState = {
  viewState: ToolsPanelViewState.MENU,
  rangeRings: {
    points: [],
  },
  measuringTool: {
    measurements: [],
  },
};

const ToolsSlice = createSlice({
  name: 'tools',
  initialState: INITIAL_TOOLS_STATE,
  reducers: {
    setToolsPanelViewState: (
      state,
      action: PayloadAction<ToolsState['viewState']>
    ) => {
      state.viewState = action.payload;
    },
    setRangeRingPoints: (state, action: PayloadAction<RangeRingPoint[]>) => {
      state.rangeRings.points = action.payload;
    },
    setMeasurements: (state, action: PayloadAction<Measurement[]>) => {
      state.measuringTool.measurements = action.payload;
    },
  },
});

export const { setToolsPanelViewState, setRangeRingPoints, setMeasurements } =
  ToolsSlice.actions;

export default ToolsSlice.reducer;
